// extracted by mini-css-extract-plugin
module.exports = {"common":"popular-job-item_common__nz2pX","search-option-wide":"popular-job-item_search-option-wide__pCK29","search-option-compact":"popular-job-item_search-option-compact__FG9xN"};